import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { TaskAPI } from 'api/tasks';
import { updateTaskPrivacySagaAction } from '../actions';
import { updateTaskPrivacy } from '../slice';

function* updateTaskPrivacySaga({
  payload,
}: PayloadAction<{ taskId: number; private: boolean }>): Generator {
  if (payload) {
    const { taskId, private: isPrivate } = payload;

    yield put(updateTaskPrivacy(payload));
    yield TaskAPI.updatePrivacy(taskId, {
      private: isPrivate,
    });
  }
}

export function* watchUpdateTaskPrivacySaga(): Generator {
  yield takeLatest(updateTaskPrivacySagaAction.type, updateTaskPrivacySaga);
}
